<template>
  <NuxtPage @onLoaded="handleLoaded" />
</template>

<script setup>
import { defineEmits } from 'vue';
import { NuxtPage } from '#components';

const emit = defineEmits(['onLoaded']);

const handleLoaded = () => {
  emit('onLoaded');
};
</script>
